import { QueryClient } from "@tanstack/react-query"

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      staleTime: 0, //time of cache
      refetchOnWindowFocus: true,
    },
  },
})
